import { render, staticRenderFns } from "./zhuanhuo.vue?vue&type=template&id=5fe0f02c&scoped=true&"
import script from "./zhuanhuo.vue?vue&type=script&lang=js&"
export * from "./zhuanhuo.vue?vue&type=script&lang=js&"
import style0 from "./zhuanhuo.vue?vue&type=style&index=0&id=5fe0f02c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe0f02c",
  null
  
)

export default component.exports